import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <IndexSection />
        <UpdatesSection />
        <RankingSection />
        <AboutSection />
        <FeaturesSection />
        <TopicsSection />
        <AppSection />
        <CardsSection />
        <FaqSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}